module.exports = __webpack_public_path__ + "static/img/evaluation_success_pic@3x.72d9bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/evaluation_success_pic@3x.png
// module id = s5ZD
// module chunks = 1